
(function(){try{
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var el=e.target;el.classList.add('hy-on');io.unobserve(el);if(el.style.transitionDelay)setTimeout(function(){el.style.transitionDelay=''},900)}})},{threshold:.15});
  var go=function(){document.querySelectorAll('.hy-rv').forEach(function(el){io.observe(el)})};
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
}catch(e){document.querySelectorAll('.hy-rv').forEach(function(el){el.classList.add('hy-on')})}
try{
  var fine=matchMedia('(pointer:fine)').matches, noMotion=matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(fine&&!noMotion){
    document.querySelectorAll('.hy-pcard,.hy-tcard').forEach(function(c){
      var r=null,raf=null;
      c.addEventListener('pointerenter',function(){r=c.getBoundingClientRect();c.style.transition='transform .18s ease-out, border-color .3s ease, filter .3s ease'});
      c.addEventListener('pointermove',function(e){
        if(raf)return; raf=requestAnimationFrame(function(){raf=null;
          if(!r)r=c.getBoundingClientRect();
          var x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
          c.style.transform='translateY(-6px) perspective(760px) rotateY('+(x*5).toFixed(2)+'deg) rotateX('+(-y*4).toFixed(2)+'deg)';});
      });
      c.addEventListener('pointerleave',function(){c.style.transform='';c.style.transition='';r=null});
    });
    document.querySelectorAll('.hy-btn-gold').forEach(function(b){
      b.addEventListener('pointermove',function(e){
        var r=b.getBoundingClientRect(), x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
        b.style.transform='translate('+(x*5).toFixed(1)+'px,'+((y*4)-2).toFixed(1)+'px)';
      });
      b.addEventListener('pointerleave',function(){b.style.transform=''});
    });
  }
  var cu=function(el){var v=parseFloat(el.getAttribute('data-count')),dec=(el.getAttribute('data-count').indexOf('.')>-1),suf=el.getAttribute('data-suffix')||'',t0=null,d=1300;
    function f(t){if(!t0)t0=t;var p=Math.min(1,(t-t0)/d);p=1-Math.pow(1-p,3);
      el.textContent=(dec?(v*p).toFixed(1):Math.round(v*p).toLocaleString('en-US'))+suf;
      if(p<1)requestAnimationFrame(f)}
    requestAnimationFrame(f)};
  if(!noMotion){
    var cio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){cio.unobserve(e.target);cu(e.target)}})},{threshold:.6});
    document.querySelectorAll('[data-count]').forEach(function(el){cio.observe(el)});
  }
  var initLate=function(){

  var mob=matchMedia('(max-width:700px)').matches;
  if(mob){
    document.querySelectorAll('.hy-grid4,.hy-tgrid,.hy-ugrid,.hy-rgrid').forEach(function(g){
      var kids=[].filter.call(g.children,function(k){return k.offsetWidth>40&&!k.classList.contains('hy-cfade')});
      if(kids.length<2) return;
      var d=document.createElement('div'); d.className='hy-dots'; d.setAttribute('aria-hidden','true');
      kids.forEach(function(){d.appendChild(document.createElement('i'))});
      g.parentNode.insertBefore(d,g.nextSibling);
      d.children[0].className='hy-don';
      var sx=0,sl0=0,moved=false;
      g.addEventListener('pointerdown',function(e){sx=e.clientX;sl0=g.scrollLeft;moved=false},{passive:true});
      g.addEventListener('pointermove',function(e){if(Math.abs(e.clientX-sx)>10)moved=true},{passive:true});
      g.addEventListener('click',function(e){if(moved||Math.abs(g.scrollLeft-sl0)>10){e.preventDefault();e.stopPropagation()}},true);
      var raf=null;
      g.addEventListener('scroll',function(){ if(raf) return; raf=requestAnimationFrame(function(){raf=null;
        var step=kids[0].offsetWidth+14;
        var idx=Math.max(0,Math.min(kids.length-1,Math.round(g.scrollLeft/step)));
        if(g.scrollLeft>=g.scrollWidth-g.clientWidth-8)idx=kids.length-1;
        for(var i=0;i<d.children.length;i++) d.children[i].className = i===idx?'hy-don':'';
        var fd=g.querySelector('.hy-cfade');
        if(fd) fd.style.opacity = g.scrollLeft>g.scrollWidth-g.clientWidth-40?'0':'1';
      })},{passive:true});
      try{
        var gio=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){gio.unobserve(en.target);
          [].forEach.call(g.querySelectorAll('.hy-rv'),function(el){el.style.transitionDelay='0s';el.classList.add('hy-on')});
        }})},{rootMargin:'0px 0px 140px 0px',threshold:.01});
        gio.observe(g);
        var dsx=0,dsy=0,dsl=0,dax=null,dvx=0,dlx=0,dlt=0,draf=null;
        g.addEventListener('touchstart',function(e){var t=e.touches[0];dsx=t.clientX;dsy=t.clientY;dsl=g.scrollLeft;dax=null;dvx=0;dlx=t.clientX;dlt=e.timeStamp;if(draf){cancelAnimationFrame(draf);draf=null}},{passive:true});
        g.addEventListener('touchmove',function(e){var t=e.touches[0],dx=t.clientX-dsx,dy=t.clientY-dsy;
          if(dax===null){if(dx===0&&dy===0)return;dax=Math.abs(dx)>=Math.abs(dy)?'x':'y'}
          if(dax==='x'){if(e.cancelable)e.preventDefault();
            g.scrollLeft=dsl-dx;
            var dt=e.timeStamp-dlt;if(dt>0){dvx=(t.clientX-dlx)/dt;dlx=t.clientX;dlt=e.timeStamp}}
        },{passive:false});
        g.addEventListener('touchend',function(){if(dax!=='x')return;var v=dvx*15;
          var mx=g.scrollWidth-g.clientWidth;
          var step2=function(){v*=.94;g.scrollLeft-=v;
            if(Math.abs(v)>.4&&g.scrollLeft>0&&g.scrollLeft<mx){draf=requestAnimationFrame(step2)}else{draf=null}};
          if(Math.abs(v)>1.2){draf=requestAnimationFrame(step2)}},{passive:true});
        g.classList.add('hy-drag');
      }catch(err){}
    });
    var warm=function(){ if(!('decode' in Image.prototype)) return;
      [].forEach.call(document.querySelectorAll('.hy-grid4 img,.hy-tgrid img,.hy-ugrid img'),function(im){
        var go2=function(){im.decode().catch(function(){})};
        if(im.complete)go2(); else im.addEventListener('load',go2,{once:true});
      });
    };
    if('requestIdleCallback' in window)requestIdleCallback(warm,{timeout:2500}); else setTimeout(warm,900);
    var bar=document.querySelector('.hy-sticky');
    if(bar){ var shown=false,raf2=null;
      addEventListener('scroll',function(){ if(raf2) return; raf2=requestAnimationFrame(function(){raf2=null;
        var y=scrollY,max=document.documentElement.scrollHeight-innerHeight;
        var show=y>1300&&y<max-700;
        if(show!==shown){shown=show;bar.classList.toggle('hy-sticky-on',show)}
      })},{passive:true});
    }
  }
  var tk=document.querySelector('.hy-tick');
  if(tk){ var tgs=tk.querySelectorAll('.hy-tk-g');
    new IntersectionObserver(function(es){es.forEach(function(e){
      for(var i=0;i<tgs.length;i++) tgs[i].style.animationPlayState=e.isIntersecting?'running':'paused';
    })}).observe(tk);
  }
  };
  if(document.readyState!=='loading') initLate(); else document.addEventListener('DOMContentLoaded', initLate);
}catch(e){}})();

